module.exports = __webpack_public_path__ + "staticcomp/img/content_1.fb848b3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/3/11/content_1.jpg
// module id = V6DF
// module chunks = 39